module.exports = __webpack_public_path__ + "img/宣传页3.47430830.jpg";